exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-children .comment-children {\n  margin-left: 1.5em;\n}\n.comment {\n  border-top: 1px solid #eee;\n  position: relative;\n}\n.comment .by,\n.comment .text,\n.comment .toggle {\n  font-size: 0.9em;\n  margin: 1em 0;\n}\n.comment .by {\n  color: #828282;\n}\n.comment .by a {\n  color: #828282;\n  text-decoration: underline;\n}\n.comment .text {\n  overflow-wrap: break-word;\n}\n.comment .text a:hover {\n  color: #f60;\n}\n.comment .text pre {\n  white-space: pre-wrap;\n}\n.comment .toggle {\n  background-color: #fffbf2;\n  padding: 0.3em 0.5em;\n  border-radius: 4px;\n}\n.comment .toggle a {\n  color: #828282;\n  cursor: pointer;\n}\n.comment .toggle.open {\n  padding: 0;\n  background-color: transparent;\n  margin-bottom: -0.5em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Comment.vue?vue&type=style&index=0&lang=stylus&
// module id = 811
// module chunks = 1